import App from './components/app';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import config from './config.json';
import './styles.global.css';

ReactPixel.init(config.facebook.pixelId);
ReactGA.initialize(config.googleAnalytics.trackingId);

export default App;



// WEBPACK FOOTER //
// ./index.js